module.exports = new __parcel__URL__("status-default--dark.703eb05a.svg").toString();